import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { INutritionIntakeDetailed } from 'src/app/interfaces/NutritionIntake/INutritionIntakeDetailed';
import { NutritionIntakeService } from 'src/app/services/nutritionIntake.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';
import { NutritionIntakeAddEditComponent } from './nutrition-intake-add-edit/nutrition-intake-add-edit.component';

@Component({
  selector: 'app-nutrition-intake',
  templateUrl: './nutrition-intake.component.html',
  styleUrls: ['./nutrition-intake.component.css'],
  standalone: false,
})
export class NutritionIntakeComponent {
  public addComp = NutritionIntakeAddEditComponent;

  private destroy$ = new Subject<void>();

  nutritionIntake?: INutritionIntakeDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly nutritionIntakeService: NutritionIntakeService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: INutritionIntakeDetailed) {
    this.nutritionIntakeService.nutritionIntakeModalSub.next(true);
    this.nutritionIntakeService.nutritionIntakeEditSub.next(item);
  }

  deleteFun(id: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder2'
      )} ${this.translate.instant('Nutrition Intake record')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.nutritionIntakeService
          .deleteNutritionIntake(id.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Nutrition Intake deleted successfully'
              );
              this.nutritionIntakeService.deleteNutritionIntakeFromTable(
                id.toString()
              );
            },

            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Nutrition Intake'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Nutrition Intake record is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.nutritionIntakeService.nutritionIntakeLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.nutritionIntakeService.nutritionIntakeDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: INutritionIntakeDetailed[]) => {
        this.nutritionIntake = data;
      });

    this.nutritionIntakeService.getData();
  }
}
